import Vue from 'vue'
import config from '@/config'
import axios from 'axios'
import moment from 'moment'
import alertHelper from '@/helpers/alert'
import issueStatus from '@/helpers/issue_status';

function lastDays(issue) {
  const now = moment();
  const timestamp = moment.unix(issue.timestamp);
  const days = timestamp.diff(now, 'days')
  return days;
}

function showStreetAddress(issue) {
  const { unit, num, street } = issue.house
  let address = ''
  if (unit) {
    address += unit + '/'
  }
  if (num) {
    address += num + ' '
  }
  if (street) {
    address += street
  }
  return address
}

function showRegion(issue) {
  const { suburb, city } = issue.house
  return suburb + ', ' + city
}

function showStatus(issue) {
  switch(issue.status) {
    case issueStatus.Discard: return 'Discard';
    case issueStatus.Proposed: return 'Proposed';
    case issueStatus.Assigned: return 'Assigned';
    case issueStatus.Performed: return 'Performed';
    case issueStatus.Closed: return 'Closed';
  }
}


const state = {
  issues: [],
  selectedIssue: {},
  handymen: []
}

const getters = {
  get(state) {
    return state.issues
  },
  getIssueById(state, id) {
    const issue =  state.issues.filter(r => r.id === id)
    return issue.length > 0 ? issue[0] : {}
  },
  getSelected(state) {
    return state.selectedIssue
  },
  getHandymen(state) {
    return state.handymen;
  }
}

const mutations = {
  set(state, issues) {
    issues.sort((a, b) => a.timestamp - b.timestamp)
    const enhanced = issues.map(issue => ({
      ...issue,
      lastDays: lastDays(issue),
      showStreetAddress: showStreetAddress(issue),
      showRegion: showRegion(issue),
      showStatus: showStatus(issue),
      result: issue.result || '{}'
    }))
    Vue.set(state, 'issues', enhanced)
  },
  add(state, issue) {
    state.issues.push(issue)
  },
  update(state, issue) {
    // console.log('???commit is here', { issue })
    state.issues.forEach((d) => {
      if (d.id === issue.id) {
        Object.assign(d, {...issue,
          lastDays: lastDays(issue),
          showStreetAddress: showStreetAddress(issue),
          showRegion: showRegion(issue),
          showStatus: showStatus(issue),
        })
        Vue.set(state, 'selectedIssue', d)
      }
    })
  },
  delete(state, id) {
    state.issues.forEach((issue, index) => {
      if (issue.id === id) {
        state.issues.splice(index, 1)
      }
    })
  },
  select(state, issue) {
    Vue.set(state, 'selectedIssue', issue)
  },
  selectFromId(state, issueId) {
    const issues =  state.issues.filter(r => r.id === issueId)
    const issue = issues.length > 0 ? issues[0] : {}
    // console.log('selectedIssue', issue)
    Vue.set(state, 'selectedIssue', issue)
  },
  deleteAttachment(state, { issueId, fileId }) {
    state.issues.forEach((houseIssue) => {
      if (houseIssue.id === issueId) {
        houseIssue.files.forEach((file, index) => {
          if (file.id === fileId) {
            houseIssue.files.splice(index, 1)
          }
        })
      }
    })
  },
  setHandymen(state, handymen) {
    state.handymen = handymen;
  }
}

const actions = {
  async fetchAll({ commit }, houseId) {
    try {
      const response = await axios.get(config.apiBaseUrl + 'issue/get', {
        params: {
          house_id: houseId,
          title: 'issues'
        },
      })

      if (response.data.errno === 0) {
        let issues = response.data.data

        if (issues.length > 0) {
          issues.sort((a, b) => a.timestamp - b.timestamp)
        }
        commit('set', issues)
      } else {
        alertHelper.error(response.data.errmsg)
      }
    } catch (error) {
      alertHelper.error(error.toString())
    }
  },
  async upsert({commit}, issue) {
    try {
      const response = await axios.post(config.apiBaseUrl + 'issue/post', issue)

      if (response.data.errno === 0) {
        commit('add', Object.assign(issue, response.data.data))
        // TODO: Return this data so the view knows about this new id
        // We will not need this once we have routes for issues
        return issue.id
      } else {
        alertHelper.error(response.data.errmsg)
      }
    } catch (error) {
      alertHelper.error(error.toString())
    }
  },
  async select({commit}, issue) {
    commit('select', issue)
  },
  async fetchHandymen({commit}) {
    try {
      const response = await axios.get(config.apiBaseUrl + 'account/getHandymen')
      if (response.data.errno === 0) {
        const handymen = response.data.data
        commit('setHandymen', handymen)
        return handymen;
      } else {
        alertHelper.error(response.data.errmsg)
      }
    } catch (error) {
      alertHelper.error(error.toString())
    }
  },
  async assign({commit}, repair) {
    try {
      // const response = await axios.post(config.apiBaseUrl + 'task/confirm/', repair)

      // if (response.data.errno === 0) {
      //   const newrepair = response.data.data;
      //   console.log({ newrepair })
      //   commit('update', Object.assign(repair, newrepair))
      //   // TODO: Return this data so the view knows about this new id
      //   // We will not need this once we have routes for repairs
      //   return response.data.data.id
      // } else {
      //   alertHelper.error(response.data.errmsg)
      // }
    } catch (error) {
      alertHelper.error(error.toString())
    }
  },
  async comment({commit, dispatch}, {repair, note} ) {
    try {
      // if (note) {
      //   repair.description = note;
      // }
      // const response = await axios.post(config.apiBaseUrl + 'task/note', repair)
      // if (response.data.errno === 0) {
      //   dispatch('fetch', repair.id)
      // } else {
      //   alertHelper.error(response.data.errmsg)
      // }
    } catch (error) {
      alertHelper.error(error.toString())
    }
  },
  async finish({commit}, repair) {
    try {
      // const response = await axios.post(config.apiBaseUrl + 'task/generateReport/',  { task_id: repair.id })
      // console.log({ response: response.data})
      // if (response.data.errno === 0) {
      //   await commit('update', response.data.data)
      //   console.log('update', repair)
      // } else {
      //   alertHelper.error(response.data.errmsg)
      // }
    } catch (error) {
      alertHelper.error(error.toString())
    }
  },
  async close({dispatch}, repair) {
    try {
      // const response = await axios.get(`${config.apiBaseUrl}task/sendReport`, {params: { task_id: repair.id }})
      // if (response.data.errno === 0) {
      //   dispatch('fetch', repair.id)
      //   // commit('update', response.data.data)
      // } else {
      //   alertHelper.error(response.data.errmsg)
      // }
    } catch (error) {
      alertHelper.error(error.toString())
    }
  },
  async update({commit, dispatch}, update) {
    try {
      // const response = await axios.post(`${config.apiBaseUrl}task/update`, update)
      // if (response.data.errno === 0) {
      //   dispatch('fetch', update.id)
      // } else {
      //   alertHelper.error(response.data.errmsg)
      // }
    } catch (error) {
      alertHelper.error(error.toString())
    }
  },
  async cancel({commit}, repair) {
    try {
      // const verb = (repair.status >= repairStatus.Assigned)? 'schedule': 'cancel'
      // const response = await axios.post(config.apiBaseUrl + `task/${verb}`, repair)
      // if (response.data.errno === 0) {
      //   commit('update', Object.assign(repair, response.data.data))
      // } else {
      //   alertHelper.error(response.data.errmsg)
      // }
    } catch (error) {
      alertHelper.error(error.toString())
    }
  },
  async reopen({commit}, repair) {
    try {
      // const response = await axios.post(config.apiBaseUrl + `task/schedule`, repair)
      // if (response.data.errno === 0) {
      //   commit('update', Object.assign(repair, response.data.data))
      // } else {
      //   alertHelper.error(response.data.errmsg)
      // }
    } catch (error) {
      alertHelper.error(error.toString())
    }
  },

}

const storeModule = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations,
}

export default storeModule
